import { render, staticRenderFns } from "./converter.vue?vue&type=template&id=483b4b1b"
import script from "./converter.vue?vue&type=script&lang=js"
export * from "./converter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports